import { render, staticRenderFns } from "./MzSongsList.vue?vue&type=template&id=44a98038&"
import script from "./MzSongsList.vue?vue&type=script&lang=js&"
export * from "./MzSongsList.vue?vue&type=script&lang=js&"
import style0 from "./MzSongsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports